<template>
  <div class="space-y-2">
    <div><ConfigHelpLabel label="YouTube 链接" help-key="block_video_youtube_url" label-class="text-[10px] text-gray-500" tag="div" /><input v-model="block.data.youtube_url" @input="$emit('update')" class="w-full px-2 py-1 border border-gray-300 rounded text-xs" placeholder="https://youtu.be/xxx 或 https://www.youtube.com/watch?v=xxx" /></div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String] })
defineEmits(['update'])
onMounted(() => { if (!props.block.data) props.block.data = {} })
</script>
